import { visit } from '../../interfaces'

interface kindModalProps {
  kinds: visit[] | null
  setShowKindModal: React.Dispatch<React.SetStateAction<boolean>>
}

const KindModal = ({ kinds, setShowKindModal }: kindModalProps) => {
  return (
    <div id='reportDetailModal' className='modal'>
      <div className='modal-content grid justify-items-center rounded-md'>
        <table className='table-fixed w-full mx-auto text-2xl'>
          <tbody>
            {kinds?.map((visit: visit) => {
              return (
                <tr key={visit.id}>
                  <td className='border-2 text-center'>{visit.name}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <button
          className='bg-red-400  text-white text-xl rounded-lg px-8 py-2 mt-10 shadow-lg'
          onClick={() => {
            setShowKindModal(false)
          }}>
          <span>Cerrar</span>
        </button>
      </div>
    </div>
  )
}

export default KindModal
